<div class="landing-page-wrapper">
  <!-- 1. GLOBAL NAVIGATION HEADER (STICKY GLASSMORPHISM ISLAND) -->
  <div class="nav-outer">
    <nav class="glass-nav">
      <img src="assets/images/new-logo.png" alt="Certiplate Logo" class="logo-img" routerLink="/" />
      <div class="nav-actions">
        <a (click)="navigateToContactUs()" class="btn btn-outline nav-contact-btn">Contact Us</a>

        <div class="login-dropdown-wrapper">
          <button (click)="toggleLoginDropdown(); $event.stopPropagation()" class="btn btn-solid nav-login-btn">
            <span>Login</span>
            <span class="dropdown-chevron">▼</span>
          </button>

          <div *ngIf="isLoginDropdownOpen" class="login-dropdown-menu" (click)="$event.stopPropagation()">
            <a (click)="adminportal(); toggleLoginDropdown()" class="dropdown-item">
              <svg class="dropdown-icon" width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
              </svg>
              <span class="item-title">Admin Portal</span>
            </a>

            <a (click)="candidateportal(); toggleLoginDropdown()" class="dropdown-item">
              <svg class="dropdown-icon" width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z" />
              </svg>
              <span class="item-title">Exam Portal</span>
            </a>
          </div>
        </div>
      </div>
    </nav>
  </div>

  <!-- Figma Sticky Header Banner -->
  <div class="terms-header">
    <div class="terms-header-content">
      Terms & Conditions
    </div>
  </div>

  <!-- Figma Content Section -->
  <div class="terms-body">
    
    <div *ngIf="isLoading" class="loading-state" style="display: flex; justify-content: center; padding: 40px 0;">
      <mat-progress-spinner class="mat-spinner-color" mode="indeterminate"></mat-progress-spinner>
    </div>

    <div *ngIf="!isLoading && policyData">
      <!-- Dynamic Policy Content -->
      <div [innerHTML]="policyData.content" class="policy-content"></div>

    </div>
  </div>

  <!-- 17. FOOTER (BOTTOM NAVIGATION & LEGAL) -->
  <footer class="site-footer">
    <div class="footer-bar-container">
      <div class="footer-content-row">
        <!-- Logo (Linked to top of page) on Left -->
        <a (click)="scrollToTop()" class="footer-logo-link">
          <img src="assets/images/new-logo.png" alt="Certiplate Logo" class="footer-logo-img" />
        </a>

        <!-- Copyright Notice in Middle/Left -->
        <span class="copyright-text">@ 2026 Certiplate. All Rights Reserved by <a href="http://navriti.com"
            target="_blank" rel="noopener noreferrer" class="copyright-owner-link">NAVRITI TECHNOLOGIES PRIVATE
            LIMITED</a></span>

        <!-- Legal Links Group on Right -->
        <div class="legal-links-group">
          <a routerLink="/terms-and-conditions" class="legal-link-item">Terms and Conditions</a>
          <a routerLink="/privacy-policy" class="legal-link-item">Privacy</a>
          <a routerLink="/cookie-policy" class="legal-link-item">Cookies</a>
        </div>
      </div>
    </div>
  </footer>
</div>